// frontend/src/components/Button/Button.js
import React from 'react';
import './Button.css';

function Button({ children, onClick, type = 'button', className = '', ...props }) {
    return (
        <button 
            type={type} 
            className={`btn ${className}`} 
            onClick={onClick}
            {...props}
        >
            {children}
        </button>
    );
}

export default Button;
